import React from 'react';
import { IconButton } from 'wix-ui-tpa/cssVars';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './header.st.css';

export const Header = ({ onClose }: { onClose?: () => void }) => {
  return (
    <div className={classes.closeButton}>
      <IconButton
        icon={<Close />}
        onClick={() => {
          onClose?.();
        }}
      />
    </div>
  );
};
